/**
 * The invite code a visitor arrived with (`?ref=`), carried to account
 * creation in the `imai_ref` cookie (#6938). The auth create hook reads it
 * server-side; this module only decides when to set or clear it.
 */
export const REFERRAL_COOKIE_NAME = 'imai_ref';
export const REFERRAL_COOKIE_MAX_AGE_SECONDS = 7 * 24 * 60 * 60;
const CODE_SHAPE = /^r1[A-Za-z0-9_-]{20,140}$/;

export function referralCodeFromSearch(search: string): string | null {
  const code = new URLSearchParams(search).get('ref')?.trim() ?? '';
  return CODE_SHAPE.test(code) ? code : null;
}

export function referralCookie(code: string, secure: boolean): string {
  return [
    `${REFERRAL_COOKIE_NAME}=${encodeURIComponent(code)}`,
    'Path=/',
    `Max-Age=${REFERRAL_COOKIE_MAX_AGE_SECONDS}`,
    'SameSite=Lax',
    ...(secure ? ['Secure'] : []),
  ].join('; ');
}

export function clearedReferralCookie(secure: boolean): string {
  return [
    `${REFERRAL_COOKIE_NAME}=`,
    'Path=/',
    'Max-Age=0',
    'SameSite=Lax',
    ...(secure ? ['Secure'] : []),
  ].join('; ');
}
